import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import type { TrackerUserPatchInput } from '@pms/shared';
import { getErrorMessage } from '@/lib/errors';
import { trackingService } from '@/services/tracking.service';
import { trackerKeys } from './trackerQuery';

export function useUpdateTrackerUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, patch }: { userId: string; patch: TrackerUserPatchInput }) =>
      trackingService.updateUser(userId, patch),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: trackerKeys.users });
      queryClient.invalidateQueries({ queryKey: trackerKeys.stats });
    },
    onError: (e) => toast.error(getErrorMessage(e)),
  });
}
